import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "Building",
  [
    [
      "path",
      {
        d: "M6.5,6.16c0-.57.46-1.03,1.03-1.03h2.06c.57,0,1.03.46,1.03,1.03v2.06c0,.57-.46,1.03-1.03,1.03h-2.06c-.57,0-1.03-.46-1.03-1.03v-2.06ZM7.88,6.5v1.38h1.38v-1.38h-1.38ZM16.47,5.12c.57,0,1.03.46,1.03,1.03v2.06c0,.57-.46,1.03-1.03,1.03h-2.06c-.57,0-1.03-.46-1.03-1.03v-2.06c0-.57.46-1.03,1.03-1.03h2.06ZM16.12,7.88v-1.38h-1.38v1.38h1.38ZM6.5,11.66c0-.57.46-1.03,1.03-1.03h2.06c.57,0,1.03.46,1.03,1.03v2.06c0,.57-.46,1.03-1.03,1.03h-2.06c-.57,0-1.03-.46-1.03-1.03v-2.06ZM7.88,12v1.38h1.38v-1.38h-1.38ZM16.47,10.62c.57,0,1.03.46,1.03,1.03v2.06c0,.57-.46,1.03-1.03,1.03h-2.06c-.57,0-1.03-.46-1.03-1.03v-2.06c0-.57.46-1.03,1.03-1.03h2.06ZM16.12,13.38v-1.38h-1.38v1.38h1.38ZM6.5,23c-1.52,0-2.75-1.23-2.75-2.75V3.75c0-1.52,1.23-2.75,2.75-2.75h11c1.52,0,2.75,1.23,2.75,2.75v16.5c0,1.52-1.23,2.75-2.75,2.75H6.5ZM5.12,3.75v16.5c0,.76.62,1.38,1.38,1.38h2.75v-2.75c0-1.52,1.23-2.75,2.75-2.75s2.75,1.23,2.75,2.75v2.75h2.75c.76,0,1.38-.61,1.38-1.38V3.75c0-.76-.61-1.38-1.38-1.38H6.5c-.76,0-1.38.62-1.38,1.38ZM13.38,18.88c0-.76-.61-1.38-1.38-1.38s-1.38.61-1.38,1.38v2.75h2.75v-2.75Z",
      },
    ],
  ],
  "currentColor"
);
